module.exports = __webpack_public_path__ + "img/1190266437.9f97c101.jpg";